import React, { useState, useContext, useEffect, useRef } from "react";
import "./buildingfilterbar.css";
import { Select } from "antd";
import { useNavigate } from "react-router";
import { Popover, Slider, Input } from "antd";
import activebuilding from "../../assets/activebuilding.png";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";
import apiUrl from "../../ApiEndpoint/config";
import apiClient from "../../ApiEndpoint/apiClient";
import { BehaviorSubject, from } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";




const { Option } = Select;

const BuildingFilterbar = ({ updateMapMarkers, tableRef }) => {
  const {
    setCityLatBld,
    setCityLngBld,
    setStateLatBld,
    setStateLngBld,
    setBldLat,
    setBldLng,
    setBuildingTypeContext,
    setOwnerNameContext,
    setBuildingNameContext,
    setStateContext,
    setCityContext,
    setEnergyScoreContext,
    setFloorAreaContext,
    setEUIContext,
    state,
    city,
    cityObj,
    buildingData, setBuildingData
  } = useContext(RegisterIdContext);
  const [energyScore, setEnergyScore] = useState([0, 100]);
  const { showFilterBar, setShowFilterBar, setRegisterid, setIsFacilitiesEmpty, setGroupName } = useContext(RegisterIdContext);
  const [buildingTypes, setBuildingTypes] = useState([]);
  const [buildingNames, setBuildingNames] = useState([]);
  const [ownerNames, setOwnerNames] = useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  // const [buildingFilterData, setBuildingFilterData] = useState({});
  const [minArea, setMinArea] = useState('');
  const [debouncedMinArea, setDebouncedMinArea] = useState(minArea);
  const [minEUI, setMinEUI] = useState('');
  const [debouncedMinEUI, setDebouncedMinEUI] = useState(minEUI);

  //Selected dropdown values
  const [selectedBuldingType, setSelectedBuldingType] = useState(null);
  const [selectedBuildingName, setSelectedBuildingName] = useState(null);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedCityObj, setSelectedCityObj] = useState(null);
  const [selectedScore, setSlectedEnergyScore] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);




  //Loading filter data for auto complete
  const searchBuldingNameSubject = useRef(new BehaviorSubject(""));
  const searchBuildingTypeSubject = useRef(new BehaviorSubject(""));
  const searchOwnerSubject = useRef(new BehaviorSubject(""));
  const searchStateSubject = useRef(new BehaviorSubject(""));
  const searchCitySubject = useRef(new BehaviorSubject(""));







  const navigate = useNavigate();

  const handleClick = () => {
    setShowFilterBar(true);
    updateMapMarkers([]);
    setCityContext(null);
    setStateContext(null);
    setBuildingNameContext(null);
    setOwnerNameContext(null);
    setBuildingTypeContext(null);
    setEnergyScoreContext(null);
    setFloorAreaContext('');
    setEUIContext('');
    setRegisterid([]);
    setIsFacilitiesEmpty(false);
    setGroupName(null);
  };

  const handleChatPage = () => {
    // setShowFilterBar(true);
    handleClick()
    navigate("/");
  };

  //Refresh homestart home icon logic
  const handleReload = async () => {
    // window.location.reload(); // This reloads the entire page
    setEnergyScore([0, 100]);
    setSelectedBuldingType(null);
    setSelectedOwner(null);
    setSelectedBuildingName(null);
    setSelectedState(null);
    setSelectedCity(null);
    setCityContext(null);
    setStateContext(null);
    setBuildingNameContext(null);
    setOwnerNameContext(null);
    setBuildingTypeContext(null);
    setSlectedEnergyScore([]);
    setEnergyScoreContext([])
    setStateLatBld(null);
    setStateLngBld(null);
    setCityLatBld(null);
    setCityLngBld(null);
    setBldLat(null);
    setBldLng(null);
    setMinArea('');
    setMinEUI('');
    tableRef.current?.resetSort();
  };


  //onclickon click state value in dropdown
  useEffect(() => {
    if (state) setSelectedState(state);
  }, [state]);

  useEffect(() => {
    if (city) {
      setSelectedCity(city);
      setSelectedCityObj(JSON.stringify(cityObj));
    }
  }, [city]);

  //Load the filter bar with default values
  useEffect(() => {
    const updatebuldingDropdownList = async () => {
      const params = {
        offset: 0,
        limit: 50, // Pass the page size to the API
      };

      // Conditionally add parameters if they have values

      if (selectedBuldingType) params.buildingType = selectedBuldingType;
      if (selectedOwner) params.ownerofrecord = selectedOwner;
      if (selectedBuildingName) params.master_id = selectedBuildingName;
      if (selectedState) params.state = selectedState;
      if (selectedCity) params.city = selectedCity;
      if (selectedScore?.length > 0) params.score = JSON.stringify(selectedScore);
      if (debouncedMinArea != null && debouncedMinArea !== '') params.floor_area_min = debouncedMinArea;
      if (debouncedMinEUI != null && debouncedMinEUI !== '') params.site_eui_min = debouncedMinEUI;

      let buildingData = await apiClient.get(`${apiUrl}/building_filters`, {
        params,
      });
      //setBuildingFilterData(buildingData);
      setBuildingTypes(buildingData.data?.building_types || [])
      setOwnerNames(buildingData.data?.owners_of_record || [])
      setBuildingNames(buildingData.data?.building_names || [])
      setStates(buildingData.data?.states || []);
      setCities(buildingData.data?.cities || []);

    };
    updatebuldingDropdownList();
  }, [selectedBuldingType, selectedOwner, selectedBuildingName, selectedState, selectedCity, selectedScore]);

  //========================================================================Auto complete for filters name=======================================================================================================================>

  useEffect(() => {

    const buildingTypeSub = searchBuildingTypeSubject.current
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchText) => {
          return from(
            (async () => {
              try {
                const params = {
                  offset: 0,
                  limit: 50,
                  type: "building_type",
                };

                // Add filters if needed
                if (searchText) params.buildingType = searchText;
                if (selectedCity) params.city = selectedCity;
                if (selectedOwner) params.ownerofrecord = selectedOwner
                if (selectedBuildingName) params.master_id = selectedBuildingName;
                if (selectedState) params.state = selectedState;
                if (selectedScore?.length > 0)
                  params.score = JSON.stringify(selectedScore);
                if (debouncedMinArea != null && debouncedMinArea !== '') params.floor_area_min = debouncedMinArea;
                if (debouncedMinEUI != null && debouncedMinEUI !== '') params.site_eui_min = debouncedMinEUI;


                const response = await apiClient.get(
                  `${apiUrl}/building_auto_complete`,
                  { params }
                );

                return { response, searchText };
              } catch (err) {
                console.error("Building Type API Error:", err);
                return {
                  response: { data: { buildingTypes: [] } },
                  searchText,
                };
              }
            })()
          );
        })
      )
      .subscribe({
        next: ({ response }) => {
          const data = response?.data?.building_types || [];
          setBuildingTypes(data);
        },
      });

    const ownerSub = searchOwnerSubject.current
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchText) => {
          return from(
            (async () => {
              try {
                const params = {
                  offset: 0,
                  limit: 50,
                  type: "ownerofrecord",
                };

                // Add filters if needed
                if (searchText) params.ownerofrecord = searchText;
                if (selectedCity) params.city = selectedCity;
                if (selectedBuldingType) params.buildingType = selectedBuldingType
                if (selectedBuildingName) params.master_id = selectedBuildingName;
                if (selectedState) params.state = selectedState;
                if (selectedScore?.length > 0)
                  params.score = JSON.stringify(selectedScore);
                if (debouncedMinArea != null && debouncedMinArea !== '') params.floor_area_min = debouncedMinArea;
                if (debouncedMinEUI != null && debouncedMinEUI !== '') params.site_eui_min = debouncedMinEUI;

                const response = await apiClient.get(
                  `${apiUrl}/building_auto_complete`,
                  { params }
                );

                return { response, searchText };
              } catch (err) {
                console.error("Building Type API Error:", err);
                return {
                  response: { data: { buildingTypes: [] } },
                  searchText,
                };
              }
            })()
          );
        })
      )
      .subscribe({
        next: ({ response }) => {
          const data = response?.data?.owners_of_record || [];
          setOwnerNames(data);
        },
      });

    const buildingSub = searchBuldingNameSubject.current
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchText) => {
          return from(
            (async () => {
              try {
                const params = {
                  offset: 0,
                  limit: 50,
                  type: "building_name",
                };

                // Add filters if needed
                if (searchText) params.buildingName = searchText;
                if (selectedCity) params.city = selectedCity;
                if (selectedBuldingType) params.buildingType = selectedBuldingType
                if (selectedOwner) params.ownerofrecord = selectedOwner;
                if (selectedState) params.state = selectedState;
                if (selectedScore?.length > 0)
                  params.score = JSON.stringify(selectedScore);
                if (debouncedMinArea != null && debouncedMinArea !== '') params.floor_area_min = debouncedMinArea;
                if (debouncedMinEUI != null && debouncedMinEUI !== '') params.site_eui_min = debouncedMinEUI;

                const response = await apiClient.get(
                  `${apiUrl}/building_auto_complete`,
                  { params }
                );

                return { response, searchText };
              } catch (err) {
                console.error("Building Type API Error:", err);
                return {
                  response: { data: { buildingTypes: [] } },
                  searchText,
                };
              }
            })()
          );
        })
      )
      .subscribe({
        next: ({ response }) => {
          const data = response?.data?.building_names || [];
          setBuildingNames(data);
        },
      });

    const citiesSub = searchCitySubject.current
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchText) => {
          return from(
            (async () => {
              try {
                const params = {
                  offset: 0,
                  limit: 50,
                  type: "city",
                };

                if (searchText) params.city = searchText;
                if (selectedBuldingType) params.buildingType = selectedBuldingType;
                if (selectedOwner) params.ownerofrecord = selectedOwner;
                if (selectedBuildingName) params.master_id = selectedBuildingName;
                if (selectedState) params.state = selectedState;
                if (selectedScore?.length > 0) params.score = JSON.stringify(selectedScore);
                if (debouncedMinArea != null && debouncedMinArea !== '') params.floor_area_min = debouncedMinArea;
                if (debouncedMinEUI != null && debouncedMinEUI !== '') params.site_eui_min = debouncedMinEUI;


                const response = await apiClient.get(`${apiUrl}/building_auto_complete`, { params });
                return { response, searchText };
              } catch (err) {
                return { response: { data: { cities: [] } }, searchText };
              }
            })()
          );
        })
      )
      .subscribe({
        next: ({ response }) => {
          const data = response?.data?.cities || [];
          setCities(data);
        },
      });

    return () => {
      citiesSub.unsubscribe();
      buildingTypeSub.unsubscribe();
      ownerSub.unsubscribe();
      buildingSub.unsubscribe();
    };
  }, [selectedBuldingType, selectedOwner, selectedBuildingName, selectedState, selectedCity, selectedScore, debouncedMinArea]); // only run once

  //========================================================================================================================>
  useEffect(() => {
    dispatchByPriority();
  }, [selectedBuldingType, selectedOwner, selectedBuildingName, selectedState, selectedCity, selectedScore, debouncedMinArea, debouncedMinEUI]); // Run on initial load and when any filter changes

  const dispatchByPriority = async () => {
    if (selectedBuildingName) return await handleBuldingNameChange(selectedBuildingName);
    if (selectedCity) return await handleCityChange(selectedCityObj);
    if (selectedState) return await handleStateChange(selectedState);
    return await fetchStatewiseCount();
  };

  const fetchStatewiseCount = async () => {
    const params = {
      offset: 0,
      limit: 10, // Pass the page size to the API
    };
    if (selectedBuldingType) params.buildingType = selectedBuldingType;
    if (selectedOwner) params.ownerofrecord = selectedOwner;
    if (selectedScore?.length > 0) params.score = JSON.stringify(selectedScore);
    if (debouncedMinArea != null && debouncedMinArea !== '') params.floor_area_min = debouncedMinArea;
    if (debouncedMinEUI != null && debouncedMinEUI !== '') params.site_eui_min = debouncedMinEUI;

    apiClient
      .get(`${apiUrl}/state_building_counts`, { params })
      .then((response) => {
        let data = response.data?.state_building_counts || [];
        updateMapMarkers(data); // Set initial markers without static point
      })
      .catch((error) => console.error("Error fetching state data:", error));
  };


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMinArea(minArea);
      setFloorAreaContext(minArea);
    }, 500); // Wait 500ms after typing ends

    return () => {
      clearTimeout(handler); // Cancel timeout if input changes
    };
  }, [minArea]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMinEUI(minEUI);
      setEUIContext(minEUI);
    }, 500); // Wait 500ms after typing ends

    return () => {
      clearTimeout(handler); // Cancel timeout if input changes
    };
  }, [minEUI]);


  const handleBuildingTypeChange = async (value) => {
    setSelectedBuldingType(value || null);
    setBuildingTypeContext(value || null);

  }
  const handleOwnerChange = async (value) => {
    setSelectedOwner(value || null);
    setOwnerNameContext(value || null);
  }

  const handleEnergyScoreChange = (value) => {
    setEnergyScore(value)
    setSlectedEnergyScore(value);      // Always update
    setEnergyScoreContext(value);
    if (
      value[0] !== 0 ||
      value[1] !== 100
    ) {
      // setSlectedEnergyScore(value);
      // setEnergyScoreContext(value)
    }
  }

  const handleAreaChange = (e) => {
    const value = e.target.value;
    // Only allow empty string or valid decimal number
    if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setMinArea(value);
    }
  };

  const handleEUIChange = (e) => {
    const value = e.target.value;

    // Only allow empty string or valid decimal number
    if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setMinEUI(value);
    }
  };

  const handleBuldingNameChange = async (value) => {
    setSelectedBuildingName(value || null);
    setBuildingNameContext(value || null);
    updateMapMarkers([])
    setBldLat(null)
    setBldLng(null)

    if (value) {
      const params = {
        master_id: value,
      };



      // Construct API URL with optional SIC code
      let apiUrls = `${apiUrl}/building_list`;

      apiClient.get(apiUrls, { params })
        .then(response => {
          const data = response.data?.building_list || [];
          const bldLat = data[0]?.LATITUDE != null ? parseFloat(data[0]?.LATITUDE) : null;
          const bldLng = data[0]?.LONGITUDE != null ? parseFloat(data[0]?.LONGITUDE) : null;

          setBldLat(bldLat)
          setBldLng(bldLng)

          setBuildingData(data);
          setSelectedBuldingType(data[0]?.Master_Building_Type)
          setSelectedOwner(data[0]?.ownerofrecord)
          setSelectedState(data[0]?.state)
          setSelectedCity(data[0]?.city);

          // ✅ Construct full city object for use in handleCityChange for open city dropdown
          const cityObj = {
            city: data[0]?.city,
            state_code: data[0]?.State_Name,
            county: data[0]?.county,
            city_latitude: data[0]?.LATITUDE != null ? parseFloat(data[0]?.LATITUDE) : null,
            city_longitude: data[0]?.LONGITUDE != null ? parseFloat(data[0]?.LONGITUDE) : null
          };

          setSelectedCityObj(JSON.stringify(cityObj));
          // Pass data and lat/lng to DataPage
          updateMapMarkers(data);
        })
        .catch(error => console.error("Error fetching county data:", error));
    }

  }
  const handleStateChange = async (value) => {
    updateMapMarkers([])
    let Geocodes = states.find(item => item.State === value) || null;
    setSelectedState(value || null);
    setStateContext(value || null);
    setSelectedCity(null);
    setSelectedBuildingName(null);


    const stateLat = Geocodes ? parseFloat(Geocodes.latitude) : null;
    const stateLng = Geocodes ? parseFloat(Geocodes.longitude) : null;
    setStateLatBld(stateLat)
    setStateLngBld(stateLng)
    if (value) {
      const params = {
        state: value,
      };
      if (selectedBuldingType) params.buildingType = selectedBuldingType;
      if (selectedOwner) params.ownerofrecord = selectedOwner;
      if (selectedScore?.length > 0) params.score = JSON.stringify(selectedScore);
      // Construct API URL with optional SIC code
      let apiUrls = `${apiUrl}/city_building_counts`;

      apiClient.get(apiUrls, { params })
        .then(response => {
          const data = response.data?.city_building_counts || [];
          // Pass data and lat/lng to DataPage
          updateMapMarkers(data);
        })
        .catch(error => console.error("Error fetching county data:", error));
    }

  };

  const handleCityChange = async (cityvalue) => {
    const cityObj = cityvalue ? JSON.parse(cityvalue) : {};
    let value = cityObj?.city != null ? cityObj?.city : null;
    setSelectedCity(value || null);
    setCityContext(value || null);
    setSelectedCityObj(cityvalue);
    setSelectedBuildingName(null);
    updateMapMarkers([])


    const cityLat = cityObj?.city_latitude != null ? parseFloat(cityObj.city_latitude) : null;
    const cityLng = cityObj?.city_longitude != null ? parseFloat(cityObj.city_longitude) : null;

    setCityLatBld(cityLat)
    setCityLngBld(cityLng)

    if (value) {
      const stateParam = selectedState ? selectedState : cityObj?.state_code;
      const params = {
        city: value,
      };
      if (stateParam) params.state = stateParam;
      if (selectedBuldingType) params.buildingType = selectedBuldingType;
      if (selectedOwner) params.ownerofrecord = selectedOwner;
      if (selectedScore?.length > 0) params.score = JSON.stringify(selectedScore);

      // Construct API URL with optional SIC code
      let apiUrls = `${apiUrl}/building_list`;

      apiClient.get(apiUrls, { params })
        .then(response => {
          const data = response.data?.building_list || [];

          // Pass data and lat/lng to DataPage
          updateMapMarkers(data);
        })
        .catch(error => console.error("Error fetching county data:", error));
    }
  };


  const energyStarContent = (
    <div style={{ width: 200 }}>
      <div style={{ marginBottom: 10 }}>Energy Star Score</div>
      <Slider
        range
        min={0}
        max={100}
        value={energyScore}
        onChange={handleEnergyScoreChange}
        trackStyle={[{ backgroundColor: "#52c41a" }]}
        handleStyle={[
          { borderColor: "#52c41a", backgroundColor: "#52c41a" },
          { borderColor: "#52c41a", backgroundColor: "#52c41a" },
        ]}
      />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>{energyScore[0]}</span>
        <span>to</span>
        <span>{energyScore[1]}</span>
      </div>
    </div>
  );

  return (
    <div className="building-filter-container">
      <div className="building-row">
        {!showFilterBar && (
          <>
            {/* Home icon */}
            <div onClick={handleChatPage}>
              <i
                className="bi bi-house-fill"
                style={{
                  fontSize: "1.5rem",
                  cursor: "pointer",
                  color: "#75748B",
                }}
              ></i>
            </div>

            <div onClick={handleReload}>
              <i
                className="bi bi-arrow-clockwise"
                style={{
                  fontSize: "1.5rem",
                  cursor: "pointer",
                  color: "#75748B",
                }}
              ></i>
            </div>

            {/* Building Type Dropdown */}

            <Select
              className="filter-select"
              showSearch
              placeholder="Building Type"
              value={selectedBuldingType}
              onChange={handleBuildingTypeChange}
              onSearch={(value) =>
                searchBuildingTypeSubject.current.next(value)
              }
              onClear={() => searchBuildingTypeSubject.current.next("")}
              allowClear
              filterOption={false}
            >
              {buildingTypes.map((bldtypes) => (
                <Option
                  key={bldtypes?.Master_Building_Type}
                  value={bldtypes?.Master_Building_Type}
                >
                  {bldtypes?.Master_Building_Type}
                </Option>
              ))}
            </Select>

            {/* OwnerName Dropdown */}

            <Select
              className="filter-select"
              showSearch
              placeholder="Owner Name"
              value={selectedOwner}
              onChange={handleOwnerChange}
              onSearch={(value) => searchOwnerSubject.current.next(value)}
              onClear={() => searchOwnerSubject.current.next("")}
              allowClear
              filterOption={false}
            >
              {ownerNames.map((owner) => (
                <Option key={owner.ownerofrecord} value={owner.ownerofrecord}>
                  {owner.ownerofrecord}
                </Option>
              ))}
            </Select>

            {/* State Dropdown */}

            <Select
              className="filter-select"
              showSearch
              placeholder="Select State"
              value={selectedState} // Should be FAC_STATE
              onChange={handleStateChange}
              onSearch={(value) => searchStateSubject.current.next(value)}
              onClear={() => searchStateSubject.current.next("")}
              allowClear
              optionFilterProp="children" // Ensures search filters by STATE_NAME dont delete
            >
              {states.map((state) => (
                <Option key={state.State} value={state.State}>
                  {state.State_Name}, {state.State}
                </Option>
              ))}
            </Select>

            {/* city Dropdown */}

            <Select
              className="filter-select"
              showSearch
              placeholder="Select City"
              value={selectedCity}
              onChange={handleCityChange}
              onSearch={(value) => searchCitySubject.current.next(value)}
              onClear={() => searchCitySubject.current.next("")}
              allowClear
              filterOption={false}
            >
              {cities.map((city, index) => (
                <Option
                  key={`${index}_${city.city}`}
                  value={JSON.stringify(city)}
                >
                  {city?.city},{city.state_code}
                </Option>
              ))}
            </Select>

            {/* BuildingName Dropdown */}

            <Select
              className="filter-select"
              showSearch
              placeholder="Building Name"
              value={selectedBuildingName}
              onChange={handleBuldingNameChange}
              onSearch={(value) => searchBuldingNameSubject.current.next(value)}
              onClear={() => searchBuldingNameSubject.current.next("")}
              allowClear
              filterOption={false}
            >
              {buildingNames.map((building) => (
                <Option key={building.master_id} value={building.master_id}>
                  {building.Master_Building_Name}
                </Option>
              ))}
            </Select>

            <Popover
              content={energyStarContent}
              trigger="click"
              placement="bottom"
              visible={popoverVisible}
              onVisibleChange={(visible) => setPopoverVisible(visible)}
            >
              <button className={`filter-button ${popoverVisible ? 'glow' : ''}`}>Energy Star Score</button>
            </Popover>
            <Input
              value={minArea}
              onChange={handleAreaChange}
              placeholder="Enter > Area"
              style={{ width: 150 }}
              className='globaltxt'
            />
            <Input
              value={minEUI}
              onChange={handleEUIChange}
              placeholder="Enter > EUI"
              style={{ width: 120 }}
              className='globaltxt'
            />
            <div className="building-icon" onClick={handleClick}>
              <img
                src={activebuilding} // Use two image variants
                alt="Building Icon"
                title={
                  showFilterBar ? "Show building view" : "Show Facility view"
                }
                style={{
                  width: "26px",
                  height: "28px",
                  cursor: "pointer",
                  marginLeft: "40px",
                }}
              />
              <div>
                <p className="m-0" style={{ fontSize: '13px', fontWeight: '900', color: 'black' }}>Switch to Facility view</p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BuildingFilterbar;
